<script lang="ts" setup>
import { type HTMLAttributes } from 'vue'
import { cva, type VariantProps } from 'class-variance-authority'

import { classMerge } from '../utils'

const headingVariants = cva('font-heading text-heading tracking-normal', {
  variants: {
    variant: {
      h1: 'text-heading-xl md:text-heading-3xl',
      h2: 'text-heading-lg md:text-heading-2xl',
      h3: 'text-heading-md md:text-heading-xl',
      h4: 'text-heading-sm md:text-heading-lg'
    }
  },
  defaultVariants: {
    variant: 'h1'
  }
})

export type HeadingProps = VariantProps<typeof headingVariants>

withDefaults(defineProps<{
  variant?: HeadingProps['variant'],
  twClass?: HTMLAttributes['class']
}>(), {
  variant: 'h1',
  twClass: ''
})

</script>

<template>
  <component :is="variant"
             :class="classMerge(headingVariants({ variant }), twClass)">
    <slot />
  </component>
</template>
